// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__3v9Zy","subHeading":"styles__subHeading__1pXZe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupFooter/styles.scss
// module id = 416
// module chunks = 0